module.exports = __webpack_public_path__ + "static/media/BreakingNews.d673fe59.png";